import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Routes from './routes/Routes';

// @redux
import { connect } from 'react-redux';
import * as userActions from './redux/actions/userActions';
import * as menuActions from './redux/actions/menuActions';

// @b2b-permissions
import { B2BPermissionsProvider } from './context/B2BPermissionsContext';

import * as Session from './pages/Login/Session/Session';
import useInactivityLogout from './pages/Login/Session/useInactivityLogout';

import Theme, { LIGHT_THEME } from './design-system/theme'
import lightTheme from './design-system/theme/light'

import './design-system/assets/styles/styles.scss';

function App(props) {
	let sessionCookie = Session.getSessionCookie();
	let permissionRoles = JSON.parse(localStorage.getItem("permissions") || "[]");
	const LOGIN_PLATFORM_TALISIS_COOKIE = Session.getCookie("LOGIN_PLATFORM_TALISIS");

	// Cierra la sesión tras 30 min de inactividad para evitar que se vuelva "rancia"
	// (token backend caducado → endpoint de permisos con datos degradados).
	useInactivityLogout();

	const handleUnload = () => {
		// ...
	};

	React.useEffect(() => {
		let isLoggedIn = Session.userIsLoggedIn();
		// Bi-directional login with www.talisis.com
		if (LOGIN_PLATFORM_TALISIS_COOKIE && sessionCookie) {
			sessionCookie["ignore_admin_talisis_cookie"] = true;
			if (permissionRoles && permissionRoles.length > 0) {
				for (let permissionRole of permissionRoles) {
					if (permissionRole.role_id === 34) { // se cambio el 2 por el  nuevo rol 34
						isLoggedIn = true;
						break;
					}
				}
			}
		}

		if (isLoggedIn) {
			props.applyUser(sessionCookie);
			props.applyPermission(sessionCookie);
			// ...
		} else {
			// IMPORTANTE: NO tocar el storage de MSAL aquí. Este `else` corre en
			// el primer render al VOLVER de Microsoft a /auth, cuando la cookie de
			// sesión todavía no está seteada (isLoggedIn=false por un instante) y
			// MSAL aún no completó handleRedirectPromise. Limpiar/filtrar el
			// storage en ese momento borra el estado de interacción del redirect
			// → "no interaction in progress" → login roto. Dejamos el clear
			// original; la preservación del refresh token se hace solo en
			// Session.setSessionCookie (ya con la sesión establecida).
			localStorage.clear();
		}

		window.addEventListener("unload", handleUnload);
        return () => {
            window.removeEventListener("unload", handleUnload);
        }

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<BrowserRouter>
			<div>
				<Theme prefersTheme={LIGHT_THEME} theme={lightTheme}>
					<B2BPermissionsProvider>
						<Routes />
					</B2BPermissionsProvider>
				</Theme>
			</div>
		</BrowserRouter>
	);
}

const mapStateToProps = ({ userReducer, menuReducer }) => ({
	...userReducer, ...menuReducer
});
const mapDispatchToProps = { ...userActions, ...menuActions };
export default connect(mapStateToProps, mapDispatchToProps)(App);
